import React from 'react';
import './PricingCard.css';
import GlowBorderWrapper from '../glow-border/GlowBorderWrapper';
import DoneIcon from '@mui/icons-material/Done';
import useIsUSD from '@/hooks/useIsUSD';

const PricingCard = ({
	plan,
	billingCycle,
	isMostPopular = false,
	isSelected = false,
	selectedSeatId,
	onSeatChange,
	onSelectPlan,
	isMobile = false
}) => {
	const activeSeat = plan.hasSeatSelection
		? plan.seats.find(seat => seat.seatId === selectedSeatId) ?? plan.seats[0]
		: null;
	const activePlan = activeSeat ?? plan;
	const monthlyPrice =
		billingCycle === 'yearly'
			? (Number(activePlan.price) / 12).toFixed(2)
			: Number(activePlan.price).toFixed(2);
	const { isUSD } = useIsUSD();
	const Icon = plan.icon;
	const ctaLabel = plan.hasSeatSelection ? 'Get Started' : 'Start Free Trial';
	const seatGroupName = `seat-${billingCycle}-${plan.id}-${isMobile ? 'mobile' : 'desktop'}`;

	const cardBody = (
		<article
			className={`
  onboarding-pricing-card
  ${isMostPopular ? 'is-most-popular' : ''}
  ${isSelected ? 'is-selected' : ''}
  ${isMostPopular ? 'is-center-card' : ''}
`}

		>
			{isMostPopular && (
				<div className="onboarding-pricing-card__popular-badge">Most Popular</div>
			)}

			<div className="onboarding-pricing-card__inner">
				<div className="onboarding-pricing-card__header">
					<div className="onboarding-pricing-card__title-row">
						{Icon && <Icon fontSize="small" />}
						<h3>{plan.title}</h3>
					</div>
					{plan.description && <p className="onboarding-pricing-card__description">{plan.description}</p>}

					{plan.hasSeatSelection && (
						<div className="onboarding-pricing-card__seat-row">
							<span>Select:</span>
							{plan.seats.map(seat => {
								const checked = activePlan.seatId === seat.seatId;
								return (
									<label key={seat.seatId}>
										<input
											type="radio"
											name={seatGroupName}
											value={seat.seatId}
											checked={checked}
											onChange={() => onSeatChange?.(seat.seatId)}
										/>
										{seat.seatLabel}
									</label>
								);
							})}
						</div>
					)}
				</div>

				<div className="onboarding-pricing-card__price-wrap">
					<p className="onboarding-pricing-card__price">
						${monthlyPrice}{!isUSD && <span className="onboarding-pricing-card__price-currency"> USD</span>} <span>per month</span>
					</p>
					{billingCycle === 'yearly' && (
						<p className="onboarding-pricing-card__billing-note">
							${Number(activePlan.price).toFixed(2)}{!isUSD && ' USD'} billed yearly
						</p>
					)}
				</div>

				<button
					type="button"
					className="onboarding-pricing-card__cta"
					onClick={() => onSelectPlan?.({ id: activePlan.seatId ?? plan.id, cbItem: activePlan.cbItem })}
				>
					{ctaLabel}
				</button>

				<div className="onboarding-pricing-card__perks">
					<h4>{activePlan.perks?.title ?? 'Includes'}</h4>
					<ul>
						{activePlan.perks?.features?.map(feature => (
							<li key={feature}>
								<DoneIcon/>
								{feature}
							</li>
						))}
					</ul>
				</div>
			</div>
		</article>
	);

	return (
		<div className={`onboarding-pricing-card__outer ${isMostPopular ? 'is-most-popular' : ''}`}>
			{isMostPopular && !isMobile ? <GlowBorderWrapper >{cardBody}</GlowBorderWrapper> : cardBody}
		</div>
	);
};

export default PricingCard;
